package app.smartcoding.realrate.domain.model.creditCardField

import androidx.compose.ui.text.input.TextFieldValue

sealed interface PaymentField: Field {
    data class PaymentTotal(override val textFieldValue: TextFieldValue, override val delta: Double) : PaymentField
    data class MainPayment(override val textFieldValue: TextFieldValue, override val delta: Double) : PaymentField
    data class Insurance(override val textFieldValue: TextFieldValue, override val delta: Double) : PaymentField
    data class Fees(override val textFieldValue: TextFieldValue, override val delta: Double) : PaymentField
}